import { render, staticRenderFns } from "./ChapterView.vue?vue&type=template&id=22fa5a32&"
import script from "./ChapterView.vue?vue&type=script&lang=js&"
export * from "./ChapterView.vue?vue&type=script&lang=js&"
import style0 from "./ChapterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports